import React from "react";
import moment from "moment";
import { CiRead } from "react-icons/ci";

const NotificationDropdown = ({
    showNotifications,
    notifications,
    makeAllNotificationSeen,
    makeNotificationSeen
}) => {
    return (
        <div className={`notification-wrapper ${showNotifications ? 'show' : ''}`}>
            <div className={`notification-dropdown ${showNotifications ? 'active' : ''}`}>
                <div className="notification-header d-flex justify-content-between align-items-center" style={{ padding: "15px" }}>
                    <span>Notifications</span>
                    {notifications?.notifications?.length > 0 && (
                        <button
                            onClick={makeAllNotificationSeen}
                            style={{ color: 'white', textDecoration: 'none' }}
                            className="btn btn-sm p-1"
                        >
                            Mark all as read
                        </button>
                    )}
                </div>
                <div className="notification-list">
                    {!notifications?.notifications?.length ? (
                        <div className="notification-empty">No new notifications</div>
                    ) : (
                        notifications.notifications.map((item, index) => (
                            <div
                                className={`notification-item ${!item.seen ? 'unread' : ''}`}
                                key={index}
                            >
                                <div className="notification-title d-flex justify-content-between">
                                    {item.title}
                                    {!item.seen && (
                                        <CiRead
                                            onClick={() =>
                                                makeNotificationSeen({ notification_id: [item.id] })
                                            }
                                            className="text-blue-500"
                                            title="Mark as read"
                                        />
                                    )}
                                </div>
                                <div className="notification-date">
                                    {item.description}
                                </div>
                                <div className="notification-date">
                                    {moment(item.created_at).fromNow()}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default NotificationDropdown